import React from 'react'
import {
  KnowledgeCard as Card,
  CardIconWrapper,
  CardIcon,
  CardTitle,
  CardDescription
} from './KnowledgeStyles'

interface KnowledgeCardProps {
  icon: string
  title: string
  description: string
}

const KnowledgeCard: React.FC<KnowledgeCardProps> = ({ icon, title, description }) => {
  return (
    <Card>
      <CardIconWrapper>
        <CardIcon>{icon}</CardIcon>
      </CardIconWrapper>
      <div>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </div>
    </Card>
  )
}

export default KnowledgeCard
